import React from 'react';
import { Container } from 'reactstrap';
import { ColumnDef } from '@tanstack/react-table';
import AspectsTable from '../AspectsTable/AspectsTable';
import { TJoint } from '../../../lib/types';
import classes from './JointViewForm.module.scss';

export const columns: ColumnDef<TJoint>[] = [
  {
    header: 'Joint Number',
    accessorKey: 'jointNumber',
  },
  {
    header: 'Tag Id',
    accessorKey: 'tagId',
  },
  {
    header: 'P&ID No',
    accessorKey: 'pIdNo',
  },
  {
    header: 'Additional Details',
    accessorKey: 'additionalDetails',
  },
  {
    header: 'Supervised Assembly',
    accessorKey: 'supervisedAssembly',
  },
  {
    header: 'Flange Size',
    accessorKey: 'flangeSize',
  },
  {
    header: 'Rating',
    accessorKey: 'rating',
  },
  {
    header: 'Bolt Diameter',
    accessorKey: 'boltDiameter',
  },
  {
    header: 'Bolt Qty',
    accessorKey: 'boltQuantity',
  },
  {
    header: 'Bolt Length',
    accessorKey: 'boltLength',
  },
  {
    header: 'Bolt Material',
    accessorKey: 'boltMaterial',
  },
  {
    header: 'Gasket Type',
    accessorKey: 'gasketType',
  },
  {
    header: 'Torque Value',
    accessorKey: 'torqueValue',
  },
  {
    header: 'Hydraulic Tool Ref',
    accessorKey: 'hydraulicToolRef',
  },
  {
    header: 'Hydraulic Tool Pass',
    accessorKey: 'hydraulicToolPass',
  },
  {
    header: 'Hydraulic Tool Pump Press',
    accessorKey: 'hydraulicToolPumpPressure',
  },
];

export const sbtColumns: ColumnDef<TJoint>[] = [
  {
    header: 'Joint Number',
    accessorKey: 'jointNumber',
  },
  {
    header: 'Tag Id',
    accessorKey: 'tagId',
  },
  {
    header: 'P&ID No',
    accessorKey: 'pIdNo',
  },
  {
    header: 'Additional Details',
    accessorKey: 'additionalDetails',
  },
  {
    header: 'Supervised Assembly',
    accessorKey: 'supervisedAssembly',
  },
];

type Props = {
  joints: TJoint[];
  isLoading: boolean;
  type: string;
};
const JointViewForm: React.FC<Props> = ({ joints, isLoading, type }) => {
  return (
    <Container fluid className={classes.container}>
      {isLoading ? (
        <div className={classes.loading}>
          Loading...
        </div>
      ) : (
        <div className={classes.tableWrapper}>
          <AspectsTable<TJoint>
            hideSelectionColumn
            title="All Joints"
            aspectName="joint"
            data={joints}
            columns={type === 'SBT' ? sbtColumns : columns}
            defaultSortingColumn="jointNumber"
            creationDisabled={true}
            getRowMutationDisabled={() => {
              return true;
            }}
            getRowDeletionDisabled={() => {
              return true;
            }}
            searchEnabled={false}
            isLoading={isLoading}
          />
        </div>
      )}
    </Container>
  );
};

export default JointViewForm;
